import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ApplicationState } from "../../../store";
import * as Service from "../../../store/service";
import * as ConfigurationActions from "../../../store/configurationService/actions";

interface IProps {
    location: any;
}

type ISocialMediaProps = IProps;

const SocialMediaCallback: React.FunctionComponent<ISocialMediaProps> = (props) => {
    const dispatch = useDispatch();
    const routeLoading = useSelector((state: ApplicationState) => state.configurationState && (state.configurationState.loading || false));

    useEffect(() => {
        const query = new URLSearchParams(props.location.search);
        const userGuid = query.get("user_guid");
        Service.confirmMonitoring(userGuid)
            .then((data) => {
                Service.startAnalyzePersonalityInsightsData(userGuid);
                var timer = setInterval(function () {
                    clearInterval(timer);
                    window.close();
                }, 1000);
            })
            .catch(function (error) {
                window.close();
            });
    });

    useEffect(() => {
        if (routeLoading) {
            dispatch(ConfigurationActions.actionCreators.setRouteLoading(false));
        }
    }, [dispatch, routeLoading]);

    return (
        <div role="row" className="data-row row">
            <div className="box loading" style={{ width: "100%" }}></div>
        </div>
    );
};

export default SocialMediaCallback;
